module.exports = __webpack_public_path__ + "img/img_gfx@2x (1).86c90881.png";